import { render, staticRenderFns } from "./CreateHealthcheck.vue?vue&type=template&id=372cee3f&"
import script from "./CreateHealthcheck.vue?vue&type=script&lang=js&"
export * from "./CreateHealthcheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports